<script>
export default {
  name: "DeliveryUnitServicesTable",
  created(){
    this.changeCampus(this.$store.state.data.selectedCampus.id);
  },
  data(){
    return {
      loading: false,
      services: [],
      filter: '',
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filterOn: [],
      sortBy: "type",
      sortDesc: false,
      fields: [
        {
          key: "serviceName",
          sortable: true,
        },
      ],
    }
  },
  computed: {
    rows() {
      return this.services.length;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async changeCampus(id){
      this.loading = true;
      await this.getServices(id);
      this.loading = false;
    },
    dropData(data) {
      this.$emit("dropData", data[0]);
    },
    async getServices(id){
      await this.$store
        .dispatch("deliveryunitservices/getDeliveryUnitServicesByCampus", id)
        .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.map(item => {
              item.templates = []
          });
            this.services = res.data;
        })
        .catch((error) => {
            this.showToast("Something went wrong! Cannot fetch delivery unit services.", "error");
        });
    },
  }
};
</script>
<template>
  <div>
    <div id="tickets-table_filter" class="dataTables_filter">
      <label class="d-inline-flex align-items-center">
        Search:
        <b-form-input
            autocomplete="off"
            v-model="filter"
            type="search"
            placeholder="Search..."
            class="form-control form-control-sm ms-2"
        ></b-form-input>
      </label>
    </div>
    <div class="table-responsive mb-0">
      <b-table
        class="datatables"
        :items="services"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        :busy="loading"
        @filtered="onFiltered"
        bordered
        outlined
        hover
        striped
        show-empty
        select-mode="single"
        selectable
        @row-selected="dropData"
        selected-variant="success"
    >
        <template #empty="scope">
            <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
            <div
                class="d-flex justify-content-center align-items-center"
            >
                <div class="preloader-component me-2">
                    <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                        </div>
                    </div>
                </div>
                <strong>Loading...</strong>
            </div>
        </template>
        <template #cell(serviceName)="row">
          <p class="mb-0">{{row.item.serviceName}}</p>
          <small>{{row.item.deliveryUnit.name}}</small>
        </template>
      </b-table>
    </div>
    <div class="row">
        <div class="col">
            <div
                class="dataTables_paginate paging_simple_numbers float-end"
            >
                <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>